<script>
import View from '@/views/View'

export default {
  name: 'invite',
  metaInfo: { title: 'Special invitation' },
  extends: View,
  components: {
    componentRedeemInvitationSection: () => import('./sections/RedeemInvitationSection.vue')
  }
}
</script>

<template>
  <div>
    <componentRedeemInvitationSection />
  </div>
</template>
